import { useQuery } from '@tanstack/react-query';
import type { AxiosRequestConfig } from 'axios';
import { apiWrapper } from '@/apiWrapper';
import { getEndpoints } from '@/endpoints';
import type { RelevanceSearchResult } from '../types/RelevanceSearchResult';

type RelevanceSearchApiResponse = {
  results: (Omit<RelevanceSearchResult, 'id'> & {
    _id: string;
  })[];
};

const getRelevanceSearch = async (
  search: string,
): Promise<RelevanceSearchResult[]> => {
  const url = getEndpoints().relevanceSearch;
  const config: AxiosRequestConfig = {
    method: 'GET',
    params: {
      q: search,
    },
  };

  const { results } = await apiWrapper<RelevanceSearchApiResponse>(url, config);
  return results.map((e) => ({
    ...e,
    id: e._id,
  }));
};

export const useRelevanceSearch = (search: string) => {
  return useQuery({
    queryKey: ['relevanceSearch', search],
    queryFn: () => (search ? getRelevanceSearch(search) : []),
    staleTime: Number.POSITIVE_INFINITY,
  });
};
